module.exports = __webpack_public_path__ + "static/media/dog-default.672afaad.png";